// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__fy6hA","jobs":"styles_jobs__OlbYv"};